/*
 * コンサルタント ホットライン詳細 取得
 */
import { apiGetOne } from '@/actions/ApiBaseActions';
export const API_GET_ONE_PROFESSIONAL_HOTLINE = 'API_GET_ONE_PROFESSIONAL_HOTLINE';
/**
 * 案件詳細 取得
 */
export const apiGetOneProfessionalHotline = ({ path: { id } }, meta) => apiGetOne(API_GET_ONE_PROFESSIONAL_HOTLINE, `/professional/hotline/${id}`, Object.assign(Object.assign({}, meta), { id, isSnakeCase: true }));
